import { FC, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container, Typography } from '@mui/material';

import PrintView from '@components/PrintView/PrintView';
import { InquiryEntryType } from '@interfaces/inquiries';
import { handleGetPrintInquiryResponse } from '@store/features/inquiryResponse/actions';
import {
  inquiryResponseErrorSelector,
  inquiryResponseIsLoadingSelector,
  printInquiryResponseDataSelector,
  printInquiryResponseTypeSelector,
} from '@store/features/inquiryResponse/selectors';
import { removeInquiryResponseDetails } from '@store/features/inquiryResponse/slice';
import useDispatch from '@store/hooks/useDispatch';

import './style.scss';

const PrintInquiryResponsePage: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { inquiryId } = useParams();

  const data = useSelector(printInquiryResponseDataSelector);
  const inquiryType: null | InquiryEntryType = useSelector(printInquiryResponseTypeSelector);
  const isLoading = useSelector(inquiryResponseIsLoadingSelector);
  const error = useSelector(inquiryResponseErrorSelector);

  const getPrintContent = useCallback(() => {
    inquiryId && dispatch(handleGetPrintInquiryResponse(+inquiryId));
  }, [dispatch, inquiryId]);

  useEffect(getPrintContent, [getPrintContent]);

  useEffect(
    () => () => {
      dispatch(removeInquiryResponseDetails());
    },
    [dispatch],
  );

  return (
    <Container maxWidth="lg" className="page inquiry-print-response-page">
      <Typography variant="h1" className="inquiry-print-response-page__title">
        {inquiryType === InquiryEntryType.Supplement && t('inquiryResponse.title')}
        {inquiryType === InquiryEntryType.Medication && t('inquiryResponse.medicationTitle')}
      </Typography>

      <PrintView
        inquiryType={inquiryType}
        data={data}
        error={error}
        getResponse={getPrintContent}
        isLoading={isLoading}
      />
    </Container>
  );
};

export default PrintInquiryResponsePage;
